<template>

  <header class="ph4-m">

    <nav class="f3 fw2 tracked v-mid">

      <ul class="ma0 pa3 items-center list">

        <li class="ba br2 bg-white">

          <router-link to="/" class="no-underline white">
            <div class="title">
              <span class="fw6">SOJOURNER </span>
              <span class="fw4">HYMNS</span>
            </div>

          </router-link>

        </li>

      </ul>

    </nav>

  </header>

</template>

<script setup>
// No state or methods currently used
</script>

<style scoped>
header {
  background: #ffc797;
  color: white;
}

.title {
  color: #ffc797;
}
</style>
